import {
  LOGIN,
  LOGIN_PAGE_UNLOADED,
  ASYNC_START,
  UPDATE_FIELD_AUTH
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case LOGIN:
      if(action.error) {
        return { inProgress: false, loginFailed: true, errorMessage: action.payload.error };
      } else {
        return {};
      }
    case LOGIN_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      if (action.subtype === LOGIN) {
        return { ...state, inProgress: true };
      }
      break;
    case UPDATE_FIELD_AUTH:
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js